import { useState } from 'react';
import './App.css';
import Explorer from './components/Explorer';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Tabs from './components/Tabs';

function App() {
	const [activeTab, setActiveTab] = useState(0);

	function handleTabChange(tabIndex) {
		setActiveTab(tabIndex);
	}

	return (
		<div id="wrapper">
			<div className="top">
				<Navbar activeTab={activeTab} onTabChange={handleTabChange} />
				<div className="main-wrapper">
					<Explorer activeTab={activeTab} onTabChange={handleTabChange} />
					<Tabs activeTab={activeTab} onTabChange={handleTabChange} />
				</div>
			</div>
			<div className="bottom">
				<Footer />
			</div>
		</div>
	);
}

export default App;
